import d3Logo from '../../assets/d3-logo.png';
import { authState } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';
import { css, html, nothing } from '../../lib/lit.js';

class SignInView extends BaseComponent {
    static properties = {
        unavailable: { type: Boolean },
    };

    static styles = css`
        .wrap {
            max-width: 26rem;
            margin: 0 auto;
            padding: 5rem 1rem;
            text-align: center;
        }
        .brand-logo {
            height: 3.5rem;
            width: auto;
        }
    `;

    render() {
        return html`
            <div class="wrap">
                <img class="brand-logo mb-3" src=${d3Logo} alt="Dice Driven" />
                <h1 class="h4 mb-3">Dice Driven Staff</h1>
                ${this.unavailable ? this._renderUnavailable() : this._renderButton()}
            </div>
        `;
    }

    // Fail loudly at the boundary rather than redirecting into a flow that cannot
    // work: without a client id and tenant slug, d3-auth's authorize endpoint
    // rejects the request, and the user would just bounce back with no
    // explanation.
    _renderUnavailable() {
        return html`
            <div class="alert alert-danger text-start" role="alert">
                <p class="mb-1"><strong>Sign-in is not configured.</strong></p>
                <p class="mb-0">
                    This deployment is missing its d3-auth client id or tenant slug, so staff
                    sign-in cannot work. Invitation links still function.
                </p>
            </div>
        `;
    }

    _renderButton() {
        return html`
            <p class="text-muted">Sign in to the staff console.</p>
            <button class="btn btn-primary" @click=${() => authState.login()}>
                Sign in with Dice Driven
            </button>
            ${
                authState.error
                    ? html`<div class="alert alert-danger mt-3" role="alert">${authState.error}</div>`
                    : nothing
            }
        `;
    }
}

customElements.define('d3-sign-in-view', SignInView);
